









































































































































import moment from 'moment'
import isMobile from 'piramis-js-utils/lib/isMobile'
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import { errorNotificationWrapper } from '../../../../../logic/helpers/NotificationService'
import NoticeCard from '../../../../Shop/Notices/NoticeCard.vue'
import { Notice } from "../../../../Shop/Notices/types";
import { NoticesHelper } from '../../../types'

type TableProduct = {
  cost: number
  currency: string
  date: string
  description: string
  index: number
  notice_id: number
  product_img: string
  product_name: string
  sum: number
}

@Component({
  methods: {
    moment,
    isMobile,
  },
  components: {
    NoticeCard,
  }
})
export default class ProfileNotices extends Vue {
  @Prop() userId!: number

  @Prop() getNotices!: NoticesHelper['getNotices']

  @Prop() refundPayment!: NoticesHelper['refundPayment']

  isLoading = false

  loadIsPossible = true

  products: Array<TableProduct> = []

  notices: Array<Notice> = []

  offset = 0

  detailsIsOpen = false

  currentNotice: Notice | null = null

  refund(notice: Notice) {
    if (typeof this.refundPayment === "function") {
      this.refundPayment(notice)
        .then(res => {
          if (res) {
            this.updateNotice(res)
          }
        })
    }
  }

  updateNotice(notice: Notice) {
    const n = this.notices.find(n => n.id === notice.id)

    if (n) {
      n.state = notice.state
    }

    if (this.currentNotice) {
      this.currentNotice.state = notice.state
    }
  }

  selectNotice(id: number): void {
    const currentNotice = this.notices.find((notice) => notice.id === id)

    if (currentNotice) {
      this.currentNotice = currentNotice

      this.detailsIsOpen = true
    }
  }

  loadMore(page: number): void {
    if (this.loadIsPossible && page * 5 >= this.offset) {
      this.isLoading = true

      this.getNotices({
        offset: this.offset,
        limit: 5,
        customer_id: this.userId
      })
        .then(({ items }) => {
          if (items.length < 5) {
            this.loadIsPossible = false
          }

          this.notices.push(...items)

          const products: Array<any> = []

          items.forEach((notice) => {
            let product: Partial<TableProduct> = {
              currency: notice.cashRegister.currency,
              date: notice.date,
              notice_id: notice.id,
              sum: notice.sum
            }

            notice.details.forEach((detail) => {
              products.push(Object.assign({
                cost: detail.cost,
                product_img: detail.product.image,
                description: detail.product.description,
                product_name: detail.product.name,
                index: this.products.length + products.length + 1
              }, product))
            })
          })

          this.products.push(...products)

          this.offset += items.length
        })
        .catch((error) => errorNotificationWrapper(this.$t('error').toString(), error))
        .finally(() => {
          this.isLoading = false
        })
    }
  }

  created(): void {
    this.isLoading = true

    //todo: loadMore fn
    this.getNotices({
      offset: this.offset,
      limit: 15,
      customer_id: this.userId
    })
      .then(({ items }) => {
        if (items.length < 5) {
          this.loadIsPossible = false
        }

        this.notices = items

        const products: Array<any> = []

        items.forEach((notice) => {
          let product: any = {
            currency: notice.cashRegister.currency,
            date: notice.date,
            notice_id: notice.id,
            sum: notice.sum
          }

          notice.details.forEach((detail: any) => {
            products.push(Object.assign({
              cost: detail.cost,
              product_img: detail.product.image,
              description: detail.product.description,
              product_name: detail.product.name,
              index: products.length + 1
            }, product))
          })
        })

        this.offset = items.length
        this.products = products
      })
      .catch((error) => errorNotificationWrapper(this.$t('error').toString(), error))
      .finally(() => this.isLoading = false)
  }
}
